import ApiService from '@/core/services/api.service'

// action types
export const FETCH_REGIONS = 'fetchRegions'
export const UPDATE_SELECTED_REGION = 'updateSelectedRegion'

// mutation types
export const SET_REGIONS = 'setRegions'
export const SET_ERROR = 'setError'
export const SET_SELECTED_REGION = 'setSelectedRegion'

const state = {
  errors: null,
  selectedRegion: { region_id: '1', name: 'INDONESIA', isocode: 'IDN' },
  regions: {},
  isReady: false,
}

const getters = {
  isRegionReady(state) {
    return state.isReady == true ? true : false
  },
  selectedRegion(state) {
    if (state.isReady) {
      return state.selectedRegion
    }
  },
  regionOptions(state) {
    if (state.isReady) {
      const setOptions = state.regions.map(function (region) {
        return {
          region_id: `${region.region_id}`,
          name: `${region.name}`,
        }
      })

      // add indonesia object into array
      const indonesia = { region_id: '1', name: 'INDONESIA' }
      setOptions.unshift(indonesia)

      return setOptions
    }
  },
  provinceOptions(state) {
    if (state.isReady) {
      // filter only province id
      const items = state.regions.filter((region) => {
        const id = region.region_id
        return id.toString().length === 2
      })
      //map the data
      const results = items.map(function (region) {
        return {
          region_id: `${region.region_id}`,
          name: `${region.name}`,
          isocode: `${region.isocode}`,
        }
      })

      // add indonesia object into array
      const indonesia = { region_id: '1', name: 'INDONESIA', isocode: 'IDN' }
      results.unshift(indonesia)

      return results
    }
  },
  districtOptions(state) {
    if (state.isReady) {
      // filter only province id
      const items = state.regions.filter((region) => {
        const id = region.region_id
        return id.toString().length === 4
      })
      //map the data
      const results = items.map(function (region) {
        return `${region.region_id}`
      })

      return results
    }
  },
}

const actions = {
  [FETCH_REGIONS](context, payload) {
    return new Promise((resolve) => {
      ApiService.get('region/all', payload)
        .then(({ data }) => {
          // console.log('Here what post returns', data.data)
          context.commit(SET_REGIONS, data.data)
          resolve(data)
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors)
        })
    })
  },
  [UPDATE_SELECTED_REGION](context, payload) {
    context.commit(SET_SELECTED_REGION, payload)
  },
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error
  },
  [SET_REGIONS](state, regions) {
    state.regions = regions
    state.errors = {}
    state.isReady = true
  },
  [SET_SELECTED_REGION](state, selectedRegion) {
    if (selectedRegion !== null) {
      state.selectedRegion = selectedRegion
    }
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
